import classNames from "classnames";

import styles from "./Label.module.css";

interface LabelProps {
  text: string;
  title?: string;
}

/** Cutoff character length for middle truncation. */
const END_LENGTH = 13;

/**
 * Styled container used within Sidebar to render labels (files and topics).
 */
export function Label({ text, title }: LabelProps) {
  // Heuristic: If text is shorter than twice the cut off length,
  // no middle truncation needed.
  if (text.length <= END_LENGTH * 2) {
    return (
      <div
        className={classNames(styles.container, styles.labelText)}
        title={title ?? text}
      >
        {text}
      </div>
    );
  }

  const start = text.slice(0, -END_LENGTH);
  const end = text.slice(-END_LENGTH);

  return (
    <div
      className={classNames(styles.middleTruncate, styles.labelText)}
      title={title ?? text}
    >
      <span className={styles.start}>{start}</span>
      <span className={styles.end}>{end}</span>
    </div>
  );
}
